import { FormsModule } from "@angular/forms";

import { CommonModule, DatePipe } from "@angular/common";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";

import { HttpClient, HttpClientModule } from "@angular/common/http";
import {
  NgModule,
  NO_ERRORS_SCHEMA,
  CUSTOM_ELEMENTS_SCHEMA,
} from "@angular/core";

import { ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from "@angular/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { SweetAlert2Module } from "@toverux/ngx-sweetalert2";
import { ProgressHttpModule } from "angular-progress-http";
import {
  ToasterModule,
  ToasterService,
} from "angular2-toaster/angular2-toaster";
import { SelectModule } from "ng-select";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { Restangular, RestangularModule } from "ngx-restangular";
import { NgxSpinnerModule } from "ngx-spinner";
import { AppComponent } from "./app.component";
import { AttachmentModule } from "./attachment/attachment.module";
// import {FilterPipe} from "./filter.pipe";
import { RouteResolver } from "./route.resolver";
import { AuthGuard } from "./services/auth-guard.service";
import { AuthService } from "./services/auth.service";
import { AuthenticationService } from "./services/authentication.service";
import { Globals } from "./services/globals";
import { HelperService } from "./services/helper.service";
import { AlertModule } from "ngx-bootstrap/alert";
import { NgxDropzoneModule } from "ngx-dropzone";
import { UploadService } from "app/services/upload.service";
import { API_URL } from './config';
import {SafeHtmlPipe } from './safe-html';
// import { EditorModule, TINYMCE_SCRIPT_SRC} from '@tinymce/tinymce-angular';

// Function for setting the default restangular configuration
export function RestangularConfigFactory(RestangularProvider) {
  RestangularProvider.setBaseUrl(API_URL+'/api/v1/');

  /*if(localStorage.getItem('access_token')){
   RestangularProvider.setDefaultHeaders({'Authorization': 'Bearer '+localStorage.getItem('access_token')});
   }
   */
  RestangularProvider.addFullRequestInterceptor(
    (element, operation, path, url, headers, params) => {
      const bearerToken = localStorage.getItem("access_token");

      const lang = localStorage.getItem("lang")
        ? localStorage.getItem("lang")
        : "en";

      return {
        headers: Object.assign({}, headers, {
          Authorization: `Bearer ${bearerToken}`,
          "Accept-Language": `${lang}`,
        }),
      };
    }
  );

  RestangularProvider.setDefaultRequestParams("jsonp", {
    callback: "JSON_CALLBACK",
  });
  // add a response interceptor
  RestangularProvider.addResponseInterceptor(function (
    data,
    operation,
    what,
    url,
    response,
    deferred
  ) {
    // .. to look for getList operations

    if (operation === "getList") {
      const newResponse: any = [];

      newResponse.data = response.data.data;
      /*if (response.page) {
       newResponse.page = response.page;
       }*/
      return newResponse;
    }
    return response;
  });
}

// Import containers
import { FullLayoutComponent, SimpleLayoutComponent } from "./containers";

const APP_CONTAINERS = [FullLayoutComponent, SimpleLayoutComponent];

// Import components
import {
  APP_SIDEBAR_NAV,
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
} from "./components";

const APP_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV,
];

// Import directives
import {
  ActiveStatusDirective,
  AsideToggleDirective,
  FocusInputDirective,
  NAV_DROPDOWN_DIRECTIVES,
  OnlyNumberDirective,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
  TableHeadFixerDirective,
  NoRightClickDirective,
} from "./directives";

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES,
];

// Import routing module
import { AppRoutingModule } from "./app.routing";

// Import 3rd party components
import { CollapseModule, TabsModule } from "ngx-bootstrap";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";
import { NgxEditorModule } from "ngx-editor";
import { AppResetPasswordComponent } from "./components/app-reset-password/app-reset-password.component";
import { CorrectiveActionHistoryModalComponent } from "./corrective-action-history-modal/corrective-action-history-modal.component";
import { CorrectiveActionModalComponent } from "./corrective-action-modal/corrective-action-modal.component";
import { CorrectiveActionArabianModalComponent } from "./corrective-action-arabian-modal/corrective-action-arabian-modal.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { LoginComponent } from "./login/login.component";
import { RedirectionComponent } from "./redirection/redirection.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { TosterMessageService } from "./services/toster-message.service";
import { TitleCasePipe } from "./title-case.pipe";
import { P401Component } from "./views/pages/401.component";
import { HttpLoaderFactory, SharedModule } from "./shared/shared.module";
import { PageNotAccessSwalComponent } from "./page-not-access-swal/page-not-access-swal.component";
import { ReportPrintPreviewComponent } from "./report-print-preview/report-print-preview.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { DocumentAuditModalComponent } from "./document-audit-modal/document-audit-modal.component";
import { ReportPrintPreviewAlmahaComponent } from "./report-print-preview-almaha/report-print-preview-almaha.component";
import { ReportNcrPrintPreviewComponent } from "./report-ncr-print-preview/report-ncr-print-preview.component";
import { ReportRirPrintPreviewComponent } from "./report-rir-print-preview/report-rir-print-preview.component";
import {ReportRirPrintPreviewAuditComponent} from "./report-rir-print-preview-audit/report-rir-print-preview-audit.component";

import { ReportRirPrintPreviewAIComponent } from "./report-rir-print-preview-ai/report-rir-print-preview-ai.component";
import { ReportRirPrintPreviewArabianComponent } from "./report-rir-print-preview-arabian/report-rir-print-preview-arabian.component";

import { MonthlySafetyAlmahaPrintComponent } from "./monthly-safety-almaha-print/monthly-safety-almaha-print.component";
import { CorrectiveActionAlmahaModalComponent } from "./corrective-action-almaha-modal/corrective-action-almaha-modal.component";
import { CorrectiveActionAlmahaHistoryModalComponent } from "./corrective-action-almaha-history-modal/corrective-action-almaha-history-modal.component";
import { CorrectiveActionCommentForwardComponent } from "./corrective-action-comment-forward/corrective-action-comment-forward.component";
import { PrintPreviewPermitToWorkAlkhorayefComponent } from "./print-preview-permit-to-work-alkhorayef/print-preview-permit-to-work-alkhorayef.component";
import { ReportEmailForwardComponent } from "./report-email-forward/report-email-forward.component";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown";
import { ReportRirPrintPreviewAlmahaComponent } from "./report-rir-print-preview-almaha/report-rir-print-preview-almaha.component";
import { CorrectiveActionForwardAlmahComponent } from "./corrective-action-forward-almah/corrective-action-forward-almah.component";
import { QhseInformationModalComponent } from "./qhse-information-modal/qhse-information-modal.component";
import { SafetyAlertModalComponent } from "./safety-alert-modal/safety-alert-modal.component";
import { CommunicationLogPdfViewerComponent } from "./communication-log-pdf-viewer/communication-log-pdf-viewer.component";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { LanguageService } from "./services/language.service";
import { FindingsActionModalComponent } from "./findings-action-modal/findings-action-modal.component";
import { FindingsActionHistoryModalComponent } from "./findings-action-history-modal/findings-action-history-modal.component";
import { QuestionnairePopupComponent } from "./questionnaire-popup/questionnaire-popup.component";
import { ReportNcrPrintPreviewAlmahaComponent } from "./report-ncr-print-preview-almaha/report-ncr-print-preview-almaha.component";
import { CountdownModule } from "ngx-countdown";
import { CanDeactivateGuard } from "./guards/can-deactivate-guard.service";
import { PipesModule } from "./pipes/pipes.module";
import { QuizFixedTimeDirective } from "./directives/quiz-fixed-time/quiz-fixed-time.directive";
import { SupplierEvaluationFormComponent } from "./supplier-evaluation-form/supplier-evaluation-form/supplier-evaluation-form.component";
import { AddContactModalComponent } from "./supplier-evaluation-form/add-contact-modal/add-contact-modal.component";
import { AddMajorCustomerModalComponent } from "./supplier-evaluation-form/add-major-customer-modal/add-major-customer-modal.component";
import { EditMajorCustomerModalComponent } from "./supplier-evaluation-form/edit-major-customer-modal/edit-major-customer-modal.component";
import { AddProductRangeModalComponent } from "./supplier-evaluation-form/add-product-range-modal/add-product-range-modal.component";
import { AddCertificationDetailsModalComponent } from "./supplier-evaluation-form/add-certification-details-modal/add-certification-details-modal.component";
import { EditCertificationDetailsModalComponent } from "./supplier-evaluation-form/edit-certification-details-modal/edit-certification-details-modal.component";
import { DropzoneModule } from "ngx-dropzone-wrapper";
import { EditContactModalComponent } from "./supplier-evaluation-form/edit-contact-modal/edit-contact-modal.component";
import { EditProductRangeModalComponent } from "./supplier-evaluation-form/edit-product-range-modal/edit-product-range-modal.component";
import { SupplierEvaluationSuccessComponent } from "./supplier-evaluation-form/supplier-evaluation-success/supplier-evaluation-success.component";
import { AppPaginationComponent } from "./app-pagination/app-pagination.component";

import { QuestionBankModalComponent } from "./competancy/question-bank-modal/question-bank-modal.component";
import { QuestionBankNewQueAddModalComponent } from "./competancy/question-bank-add-new.component-modal/question-bank-add-new.component-modal.component";
import { QuestionBankEditViewModalComponent } from "./competancy/question-bank-edit-view-modal/question-bank-edit-view-modal.component";
import { QuestionBankEditMcqModalComponent } from "./competancy/question-bank-edit-mcq-modal/question-bank-edit-mcq-modal.component";
import { QuestionBankEditWrittenModalComponent } from "./competancy/question-bank-edit-written-modal/question-bank-edit-written-modal.component";
import { QuestionBankEditQAModalComponent } from "./competancy/question-bank-edit-qa-modal/question-bank-edit-qa-modal.component";

// import { QuestionBankEditViewComponent }  from "./competancy/question-bank-edit-view/question-bank-edit-view.component";
import { QuestionBankNewQueAddMcqComponent } from "./competancy/question-bank-add-new-mcq-modal/question-bank-add-new-mcq-modal.component";
import { QuestionBankNewQueAddWrittenComponent } from "./competancy/question-bank-add-new-written-modal/question-bank-add-new-written-modal.component";
import { QuestionBankNewQueAddQAComponent } from "./competancy/question-bank-add-new-qa-modal/question-bank-add-new-qa-modal.component";

import { AssessmentMasterModalComponent } from "./competancy/assessment-master-modal/assessment-master-modal.component";
import { AssessmentMasterEditViewAddQuestionModal } from "./competancy/assessment-master-edit-view_que-modal/assessment-master-edit-view_que-modal.component";
import { AssessmentMasterEditViewAddQuestionModalComponent } from "./competancy/assessment-master-edit-view-new-modal/assessment-master-edit-view-new-modal.component";
import { AssessmentService } from "./services/assessment.service";
import { MapDesignationService } from "./services/mapdesignation.service";
import { MapAssessmentService } from "./services/map-assessment.service";
import { AssessmentMasterQuestionService } from "./services/assessment-master-question.service";
import { AssessmentMasterDetailService } from "./services/assessment-master-detail.service";
import { AssessmentMasterHeaderService } from "./services/assessment-master-header.service";
import { AssessmentDetailService } from "./services/assessment-detail.service";
import { AssessmentHeaderService } from "./services/assessment-header.service";
import { EmployeeService } from "./services/employee.service";
import { DataService } from "./services/data.service";
import { DesignationMasterService } from "./services/designation-master.service";
import { LocalStorageService } from "./services/localStorage.service";
import { LossPreventionAccessService } from "./services/loss-prevention-access.service";
import { ConfigurationService } from "./services/configuration.service";
import { QuizViewComponent } from "./competancy/create-assessment-new/quiz-component";
import { ExamService } from "./services/exam.service";
//import { AgGridModule } from "ag-grid-angular";
// import { AssessmentMasterEditVAddLinkComponent } from "./competancy/assessment-master-edit-add_link-modal/assessment-master-edit-add-link-modal.component";
import { AssessmentStatusService } from "./services/assessment-status.service";


import { ObjectivesModalComponent } from "./competancy/objectives-modal/objectives-modal.component";
import { AddGenerateModalComponent } from "./competancy/objectives-edit-modal-generate/objectives-edit-modal-generate";
import { AddMapDesigModalComponent } from "./competancy/objectives-edit-modal-desig/objectives-edit-modal-desig";
import { EditMapDesigModalComponent } from "./competancy/objectives-edit-modal-desig-edit/objectives-edit-modal-desig-edit";


import { CreateObjectivesModal } from "./competancy/create-objectives-modal/create-objectives-modal.component";
import { CreateNewObjectivesDesignations } from "./competancy/create-new-objectives-designation/create-new-objectives-designation.component";
import { EditCreateDesigModalComponent } from "./competancy/create-new-objectives-designation-edit/create-new-objectives-designation-edit.component";


import { DataTablesModule } from 'angular-datatables';
import { SafetyReportComponent } from "./create-new-entry/monthly-safety-data-entry/safty-report.components";
//import { MyActionManagementComponent } from "./my-action-items/my-action-management/my-action-management.component";

import {TooltipModule} from 'ngx-bootstrap/tooltip';
import { DropdownService } from "./services/dropdown.service";



import { ObjectiveRatingsMasterAddComponent } from "./configuration/objective-ratings-master-modal/objective-ratings-master-modal.component";
import { ObjectiveElementsMasterAddComponent } from "./configuration/objective-elements-master-modal/objective-elements-master-modal.component";
import { ObjectiveElementsMasterAddProficiencyComponent } from "./configuration/objective-elements-proficiency-master-modal/objective-elements-proficiency-master-modal.component";
import { MyActionItemsModule } from "./my-action-items/my-action-items.module";
//import { MyActionDashboardDataComponent } from "./my-action-items/my-action-dashboard-data/my-action-dashboard-data.component";
import { CourseMasterComponent } from './course-master/course-master.component';


import { QuestionBankImportModalComponent } from "./competancy/question-bank-import-modal/question-bank-import-modal.component";
import { QuestionBankImportErrorsModalComponent } from "./competancy/question-bank-import-errors-modal/question-bank-import-errors-modal.component";

 import { DocumentModelComponent } from "app/configuration/documentModel/documentModel.component";

 import {TrainingCalenderModalComponent} from './training/training-calender-modal/training-calender-modal.component';

 import { ApprovalRoleMasterModalComponent } from "./configuration/approval-roles-master-modal/approval-roles-master-modal.component";
 import { ApprovalRoleMasterEditModalComponent } from "./configuration/approval-roles-master-edit-modal/approval-roles-master-edit-modal.component";

 import { ObjectivesEditTemplateHeaderModalComponent } from "./competancy/objectives-edit-templateheader-modal/objectives-edit-templateheader-modal.component";
 import { ObjectivesEditApprovalSettingsModalComponent } from "./competancy/objectives-edit-approvalsettings-modal/objectives-edit-approvalsettings-modal.component";


@NgModule({
  imports: [
    DataTablesModule,


    BrowserModule,
    ModalModule.forRoot(),
    TypeaheadModule.forRoot(),
    BrowserAnimationsModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
  
    HttpClientModule,
    AngularMultiSelectModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,

    SweetAlert2Module.forRoot({
      buttonsStyling: false,
      customClass: "modal-content",
      confirmButtonClass: "btn btn-primary",
      cancelButtonClass: "btn",
    }),
    RestangularModule.forRoot(RestangularConfigFactory),
    ToasterModule,
    NgxSpinnerModule.forRoot(),
    BsDatepickerModule.forRoot(),
    HttpModule,
    ReactiveFormsModule,
    ProgressHttpModule,
    TabsModule.forRoot(),
    AlertModule.forRoot(),
    NgxEditorModule,
    SharedModule,
    CollapseModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AttachmentModule,
    CountdownModule,
    PipesModule,
    DropzoneModule,
    NgxDropzoneModule,
    TooltipModule.forRoot(),
    MyActionItemsModule,
  ],
  declarations: [	
    AppComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,
    /*    DashboardComponent,*/
    LoginComponent,
    P401Component,
    RedirectionComponent,
    CorrectiveActionModalComponent,
    CorrectiveActionArabianModalComponent,
    AppResetPasswordComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    AppResetPasswordComponent,
    CorrectiveActionHistoryModalComponent,
    OnlyNumberDirective,
    TableHeadFixerDirective,
    ActiveStatusDirective,
    FocusInputDirective,
    // FilterPipe,
    TitleCasePipe,
    PageNotAccessSwalComponent,
    ReportPrintPreviewComponent,
    ReportRirPrintPreviewAIComponent,
    ReportRirPrintPreviewArabianComponent,
    PrivacyPolicyComponent,
    DocumentAuditModalComponent,
    ReportPrintPreviewAlmahaComponent,
    ReportNcrPrintPreviewComponent,
    ReportRirPrintPreviewComponent,
    ReportRirPrintPreviewAuditComponent,
    MonthlySafetyAlmahaPrintComponent,
    CorrectiveActionAlmahaModalComponent,
    CorrectiveActionAlmahaHistoryModalComponent,
    CorrectiveActionCommentForwardComponent,
    PrintPreviewPermitToWorkAlkhorayefComponent,
    ReportEmailForwardComponent,
    ReportRirPrintPreviewAlmahaComponent,
    CorrectiveActionForwardAlmahComponent,
    QhseInformationModalComponent,
    SafetyAlertModalComponent,
    CommunicationLogPdfViewerComponent,
    FindingsActionModalComponent,
    FindingsActionHistoryModalComponent,
    QuestionnairePopupComponent,
    ReportNcrPrintPreviewAlmahaComponent,
    SupplierEvaluationFormComponent,
    AddContactModalComponent,
    AddMajorCustomerModalComponent,
    EditMajorCustomerModalComponent,
    AddProductRangeModalComponent,
    AddCertificationDetailsModalComponent,
    EditCertificationDetailsModalComponent,
    EditContactModalComponent,
    EditProductRangeModalComponent,
    SupplierEvaluationSuccessComponent,
    QuestionBankModalComponent,
    QuestionBankNewQueAddModalComponent,
    QuestionBankEditViewModalComponent,
    QuestionBankEditMcqModalComponent,
    QuestionBankEditWrittenModalComponent,
    QuestionBankEditQAModalComponent,
    QuestionBankImportModalComponent,
    QuestionBankImportErrorsModalComponent,
    QuestionBankNewQueAddMcqComponent,
    QuestionBankNewQueAddWrittenComponent,
    QuestionBankNewQueAddQAComponent,
    AssessmentMasterModalComponent,
    AssessmentMasterEditViewAddQuestionModalComponent,
    ObjectivesModalComponent,
    AddGenerateModalComponent,
    AddMapDesigModalComponent,
    EditMapDesigModalComponent,

    CreateObjectivesModal,
    CreateNewObjectivesDesignations,
    EditCreateDesigModalComponent,
    SafetyReportComponent,
    SafeHtmlPipe,
    // MyActionManagementComponent,
   // MyActionDashboardDataComponent,
    ObjectiveRatingsMasterAddComponent,
    ObjectiveElementsMasterAddComponent,
    ObjectiveElementsMasterAddProficiencyComponent,
      CourseMasterComponent,
      DocumentModelComponent,
      TrainingCalenderModalComponent,
      ApprovalRoleMasterModalComponent,
      ApprovalRoleMasterEditModalComponent,
      ObjectivesEditTemplateHeaderModalComponent,
      ObjectivesEditApprovalSettingsModalComponent
   ],
  entryComponents: [
    CorrectiveActionModalComponent,
    CorrectiveActionArabianModalComponent,
    CorrectiveActionHistoryModalComponent,
    ReportPrintPreviewComponent,
    ReportRirPrintPreviewAIComponent,
    ReportRirPrintPreviewArabianComponent,
    AppResetPasswordComponent,
    DocumentAuditModalComponent,
    ReportPrintPreviewAlmahaComponent,
    ReportNcrPrintPreviewComponent,
    ReportRirPrintPreviewComponent,
    ReportRirPrintPreviewAuditComponent,
    MonthlySafetyAlmahaPrintComponent,
    CorrectiveActionAlmahaModalComponent,
    CorrectiveActionAlmahaHistoryModalComponent,
    CorrectiveActionCommentForwardComponent,
    PrintPreviewPermitToWorkAlkhorayefComponent,
    ReportEmailForwardComponent,
    ReportRirPrintPreviewAlmahaComponent,
    CorrectiveActionForwardAlmahComponent,
    QhseInformationModalComponent,
    SafetyAlertModalComponent,
    CommunicationLogPdfViewerComponent,
    FindingsActionModalComponent,
    FindingsActionHistoryModalComponent,
    QuestionnairePopupComponent,
    ReportNcrPrintPreviewAlmahaComponent,
    AddContactModalComponent,
    AddMajorCustomerModalComponent,
    EditMajorCustomerModalComponent,
    AddProductRangeModalComponent,
    AddCertificationDetailsModalComponent,
    EditCertificationDetailsModalComponent,
    EditContactModalComponent,
    EditProductRangeModalComponent,
    QuestionBankModalComponent,
    QuestionBankNewQueAddModalComponent,
    QuestionBankEditViewModalComponent,
    QuestionBankEditMcqModalComponent,
    QuestionBankEditWrittenModalComponent,
    QuestionBankEditQAModalComponent,
    QuestionBankImportModalComponent,
    QuestionBankImportErrorsModalComponent,
    QuestionBankNewQueAddMcqComponent,
    QuestionBankNewQueAddWrittenComponent,
    QuestionBankNewQueAddQAComponent,
    AssessmentMasterModalComponent,
    AssessmentMasterEditViewAddQuestionModalComponent,
    ObjectivesModalComponent,
    AddGenerateModalComponent,
    AddMapDesigModalComponent,
    EditMapDesigModalComponent,

    CreateObjectivesModal,
    CreateNewObjectivesDesignations,
    EditCreateDesigModalComponent,
    SafetyReportComponent,
    ObjectiveRatingsMasterAddComponent,
    ObjectiveElementsMasterAddComponent,
    ObjectiveElementsMasterAddProficiencyComponent,
    DocumentModelComponent,
    TrainingCalenderModalComponent,
    ApprovalRoleMasterModalComponent,
    ApprovalRoleMasterEditModalComponent,
    ObjectivesEditTemplateHeaderModalComponent,
    ObjectivesEditApprovalSettingsModalComponent
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
      
      
    },
    AuthGuard,
    CanDeactivateGuard,
    AuthGuard,
    AuthService,
    RouteResolver,
    AuthenticationService,
    HelperService,
    DatePipe,
    TosterMessageService,
    TitleCasePipe,
    Globals,
    LanguageService,
    UploadService,
    AssessmentService,
    MapAssessmentService,
    MapDesignationService,
    AssessmentMasterQuestionService,
    AssessmentMasterDetailService,
    AssessmentMasterHeaderService,
    AssessmentDetailService,
    AssessmentHeaderService,
    EmployeeService,
    DataService,
    DesignationMasterService,
    AssessmentStatusService,
    LocalStorageService,
    LossPreventionAccessService,
    ConfigurationService,
    ExamService,
    DropdownService,
    // { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
  ],
  bootstrap: [AppComponent],
  exports: [FormsModule, ReactiveFormsModule],
})
export class AppModule {
  constructor() {}
}



// WEBPACK FOOTER //
// /app/src/app/app.module.ts